export default "__VITE_ASSET__e34a09db__"